import React from 'react';
import Avatar from 'material-ui/Avatar';
import IconButton from 'material-ui/IconButton';
import { connect } from 'react-redux';
import { GetApp } from 'material-ui-icons'
import Menu, { MenuItem } from 'material-ui/Menu';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';

import * as filedownload from '../../../actions/fileupload';

import DeleteSubDecision from './deletesubdecision';
class CardMenu extends React.Component {

    render() {
        const ITEM_HEIGHT = 40;
        const options = [
            { id: 1, name: 'View / Update' },
            { id: 2, name: 'Delete' },
        ];
        const { menuState, anchorEl, handleRequestClose } = this.props;
        return (
            <Menu id="long-menu"
                anchorEl={anchorEl}
                open={menuState}
                onClose={handleRequestClose}
                style={{ maxHeight: ITEM_HEIGHT * 4.5 }}
                MenuListProps={{
                    style: {
                        width: 150,
                        paddingTop: 0,
                        paddingBottom: 0
                    },
                }}>
                {options.map(option =>
                    option.id == 2 || this.props.id ? <MenuItem key={option.id} onClick={handleRequestClose.bind(this, option.id)}>
                        {option.name}
                    </MenuItem> : null,
                )}
            </Menu>
        );
    }

}

class TableCell extends React.Component {

    onOptionMenuSelect = event => {
        this.setState({ menuState: true, anchorEl: event.currentTarget });
    };
    handleRequestClose(data, click_id, e) {
        // console.log('handleClick', click_id);
        if (click_id == 1) {
            this.props.openAddSubDecision(data);
        }
        else if (click_id == 2) {
            this.setState({ openDeleteDialog: true });
        }
        else if (click_id == 3) {
            // this.setState({open: true});
        }
        else if (click_id == 4) {
            // console.log(this.props)
            // this.props.history.push('/user/add-user/' + userid);
        }
        this.setState({ menuState: false });
    };

    closeDialog = (data) => {
        this.setState({ openDeleteDialog: false });
    }
    deleteSubdecision(e) {
        this.props.getDeleteSubDecision(this.props.data)
    };
    constructor() {
        super();
        this.state = {
            anchorEl: undefined,
            menuState: false,
            openDeleteDialog: false,
        }
    }

    render() {
        const { anchorEl, menuState } = this.state;
        const { decision_no, decision_text, decision_status_desc, status } = this.props.data;
        const index = this.props.index;
        return (
            <tr tabIndex={-1} key={index}>
                <td>{index + 1}</td>
                <td>{decision_text}</td>
                <td>{decision_no}</td>
                <td>{decision_status_desc}</td>
                <td className="text-right">
                    <IconButton className="size-30" onClick={this.onOptionMenuSelect.bind(this)}>
                        <i className="zmdi zmdi-more-vert" /></IconButton>
                    <CardMenu menuState={menuState} anchorEl={anchorEl} id={this.props.data.id > 0 ? this.props.data.id : null}
                        handleRequestClose={this.handleRequestClose.bind(this, this.props.data)} />
                    <DeleteSubDecision open={this.state.openDeleteDialog} data={this.props.data} decision_id={this.props.id}
                        closeDialog={this.closeDialog}
                        setDeleteSubDecision={this.deleteSubdecision.bind(this)} />
                </td>
            </tr>

        );
    }
}

function mapStateToProps(state) {
    return state;
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(filedownload, dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableCell));


// WEBPACK FOOTER //
// ./app/decisiondetails/adddecision/tablecell.js